import { VIEW_TYPES } from "@/other/constants/OtherKeys";
import type { PageGuideDefinition } from "../types";

/** Target ids for Marketing Manifest — use with `guideTargetProps()` or `data-guide`. */
export const MANIFEST_GUIDE_TARGETS = {
  context: "context",
  manifestHeader: "manifest-header",
  manifestBody: "manifest-body",
  tagsBreadcrumb: "tags-breadcrumb",
  provenance: "provenance",
  expandManifest: "expand-manifest",
  emptyState: "empty-state",
} as const;

export const marketingManifestGuide: PageGuideDefinition = {
  id: "marketing-manifest-v1",
  viewType: VIEW_TYPES.marketingManifest,
  steps: [
    {
      target: MANIFEST_GUIDE_TARGETS.context,
      placement: { side: "bottom", align: "start" },
      title: "Start with Context",
      body: "Context is your input — business details, services, and positioning. Swivu uses it to build everything downstream.",
    },
    {
      target: MANIFEST_GUIDE_TARGETS.manifestHeader,
      placement: { side: "bottom", align: "start" },
      title: "Your blueprint",
      body: "The manifest is read-only here. Update it by editing Context and making it active.",
    },
    {
      target: MANIFEST_GUIDE_TARGETS.tagsBreadcrumb,
      placement: { side: "bottom", align: "start" },
      title: "View your tags",
      body: "Tags are generated automatically when you activate Context. Click Tags to browse problem, solution, and meta tags.",
    },
    {
      target: MANIFEST_GUIDE_TARGETS.provenance,
      placement: { side: "top", align: "start" },
      title: "Source and sync",
      body: "See which Context created this manifest and when it last synced.",
    },
    {
      target: MANIFEST_GUIDE_TARGETS.expandManifest,
      placement: { side: "left", align: "center" },
      title: "Focus mode",
      body: "Expand long manifests for easier reading. Press Esc to exit focus mode.",
    },
  ],
};

export const marketingManifestSetupGuide: PageGuideDefinition = {
  id: "marketing-manifest-v1-setup",
  viewType: VIEW_TYPES.marketingManifest,
  steps: [
    {
      target: MANIFEST_GUIDE_TARGETS.context,
      placement: { side: "bottom", align: "start" },
      title: "Start with Context",
      body: "Set up Context with your business details first. Your manifest and tags are generated automatically once Context is active.",
    },
    {
      target: MANIFEST_GUIDE_TARGETS.emptyState,
      placement: { side: "top", align: "center" },
      title: "Your manifest will appear here",
      body: "Once Context is active, this page fills in with your read-only marketing blueprint.",
    },
    {
      target: MANIFEST_GUIDE_TARGETS.provenance,
      placement: { side: "top", align: "start" },
      title: "Track your source",
      body: "This footer links back to Context so you can update inputs anytime.",
    },
  ],
};
